var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrequency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "frequency",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.477,
    height: 49.009,
    viewBox: "0 0 50.477 49.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_87652",
    "data-name": "Path 87652",
    d: "M111.81,47.355a1.781,1.781,0,0,0-1.78,1.779V61.908a1.78,1.78,0,1,0,3.559,0V49.134A1.781,1.781,0,0,0,111.81,47.355Z",
    transform: "translate(-63.112 -30.599)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87653",
    "data-name": "Path 87653",
    d: "M97.577,29.568a1.782,1.782,0,0,0-1.78,1.78V60.041a1.779,1.779,0,1,0,3.559,0V31.348A1.781,1.781,0,0,0,97.577,29.568Z",
    transform: "translate(-55.583 -21.19)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87654",
    "data-name": "Path 87654",
    d: "M83.348,11.779a1.781,1.781,0,0,0-1.779,1.78v45.45a1.779,1.779,0,0,0,3.559,0V13.559A1.782,1.782,0,0,0,83.348,11.779Z",
    transform: "translate(-48.056 -11.779)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87655",
    "data-name": "Path 87655",
    d: "M69.116,23.337a1.782,1.782,0,0,0-1.779,1.779V59.679a1.779,1.779,0,1,0,3.558,0V25.116A1.781,1.781,0,0,0,69.116,23.337Z",
    transform: "translate(-40.527 -17.893)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87656",
    "data-name": "Path 87656",
    d: "M54.887,39.125a1.782,1.782,0,0,0-1.78,1.779V60.6a1.78,1.78,0,1,0,3.559,0V40.9A1.782,1.782,0,0,0,54.887,39.125Z",
    transform: "translate(-32.999 -26.245)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87657",
    "data-name": "Path 87657",
    d: "M40.656,15.337a1.782,1.782,0,0,0-1.779,1.779v42.1a1.779,1.779,0,1,0,3.558,0v-42.1a1.779,1.779,0,0,0-1.779-1.781Z",
    transform: "translate(-25.472 -13.661)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87658",
    "data-name": "Path 87658",
    d: "M26.425,33.125A1.781,1.781,0,0,0,24.646,34.9V60.247a1.779,1.779,0,1,0,3.559,0V34.9A1.782,1.782,0,0,0,26.425,33.125Z",
    transform: "translate(-17.943 -23.071)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87659",
    "data-name": "Path 87659",
    d: "M12.195,47.356a1.782,1.782,0,0,0-1.78,1.779V61.073a1.779,1.779,0,1,0,3.559,0V49.136a1.779,1.779,0,0,0-1.779-1.78Z",
    transform: "translate(-10.415 -30.599)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrequency);
export default __webpack_public_path__ + "static/media/frequency.583bc632b795cbc1f5d2857a847ce215.svg";
export { ForwardRef as ReactComponent };